import React from 'react';
import { LicenseFeature } from '@/types/license';

interface FeatureItemProps {
  feature: LicenseFeature;
}

export const FeatureItem: React.FC<FeatureItemProps> = ({ feature }) => {
  return (
    <li className="flex items-center text-sm">
      <span className={`w-5 h-5 rounded-full flex items-center justify-center mr-2 ${
        feature.included ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'
      }`}>
        {feature.included ? '✓' : '×'}
      </span>
      <span className="text-gray-700">{feature.name}</span>
      {feature.additionalInfo && (
        <span className="ml-2 text-xs text-gray-500">
          ({feature.additionalInfo})
        </span>
      )}
    </li>
  );
};